const firebaseConfig = {
    apiKey: "AIzaSyAZMCoyaV4ksAbUOV4Cll_vCq8mWJwKTS0",
    authDomain: "cholo-ghuri-88152.firebaseapp.com",
    projectId: "cholo-ghuri-88152",
    storageBucket: "cholo-ghuri-88152.appspot.com",
    messagingSenderId: "584097062957",
    appId: "1:584097062957:web:fdb4494acc99a589cb58a4"
  };

  export default firebaseConfig;